import { createTheme } from '@mui/material';
import { colors } from '@assets/colors';

import { GridSystemValues } from './grid-system-values.enum';
import { ptBR as corePtBR } from '@mui/material/locale';
import { ptBR } from '@mui/x-date-pickers/locales';

export const theme = createTheme(
    {
        palette: {
            primary: {
                ...colors.theme.primary
            },
            secondary: {
                ...colors.theme.secondary
            }
        },
        breakpoints: {
            values: {
                xs: GridSystemValues.xs,
                sm: GridSystemValues.sm,
                md: GridSystemValues.md,
                lg: GridSystemValues.lg,
                xl: GridSystemValues.xl
            }
        },
        typography: {
            fontFamily: ['-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(
                ','
            )
        },
        shape: {
            borderRadius: 8
        },
        components: {
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        padding: '6px 10px'
                    }
                }
            }
        }
    },
    corePtBR,
    ptBR
);
